<template>
  <div class="main">
    <a-row class="h-full w-full">
      <a-col :xs="0" :sm="0" :md="13" :lg="14" :xl="14" class="h-full">
        <div class="left h-full"></div>
      </a-col>
      <a-col :xs="24" :sm="24" :md="11" :lg="10" :xl="10" class="h-full">
        <a-row class="w-full h-full">
          <a-col :xs="2" :sm="2" :md="3" :lg="4" :xl="5"></a-col>
          <a-col :xs="20" :sm="20" :md="18" :lg="16" :xl="14" class="h-full">
            <tk-flex middle center column class="right h-full p-b-32 w-full">
              <div class="w-full">
                <h1 class="font-bold font-32 m-b-10">欢迎使用AI测虫系统！</h1>
                <h5 class="font-14 text-color">Welcome to AI Pest Testing System!</h5>
              </div>
              <a-form
                id="formLogin"
                class="user-layout-login w-full"
                style="margin-top: 50px;"
              >
                <a-form-item label="账号" class="w-full">
                  <a-input
                    size="large"
                    type="text"
                    placeholder="请输入"
                    v-model="username"
                  >
                  </a-input>
                </a-form-item>

                <a-form-item label="密码">
                  <a-input
                    size="large"
                    type="password"
                    autocomplete="false"
                    placeholder="请输入"
                    v-model="password"
                  >
                  </a-input>
                </a-form-item>

                <a-form-item class="m-b-32 w-full" style="margin-top:60px">
                  <button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    class="login-button w-full font-16"
                    :loading="loading"
                    @click="login"
                  >
                    登录
                  </button>
                </a-form-item>
              </a-form>
            </tk-flex>
          </a-col>
          <a-col :xs="2" :sm="2" :md="3" :lg="4" :xl="5"></a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import './login.scss'
export default {
  layout: 'user',
  data () {
    return {
      username: '',
      password: '',
      loading: false
    }
  },
  mounted () {},
  methods: {
    async login () {
      if (!this.username || !this.password) {
        this.$notification['error']({
          message: '错误',
          description: '请填写账号和密码'
        })
        return
      }
      this.loading = true
      try {
        if (process.env.VUE_APP_TYPE_TEST === 'single') {
          let count = await this.$tkParse.get(`/classes/_User/`, {
            params: {
              count: 1,
              limit: 0
            }
          })
          if (count.data.count === 0) {
            // let newres =
            await this.$tkParse.post('/init/init')
          }
        }
        let res = await this.$tkParse.post('/login', {
          username: this.username,
          password: this.password
        })
        await this.$store.dispatch('initUser', res.data)
        if (process.env.VUE_APP_TYPE_TEST === 'single') {
          this.$router.push({
            path: '/grainstore/detail',
            query: { store: 'aaaaaaaaaa', type: 'summary' }
          })
        } else {
          this.$router.push('/')
        }
      } catch (e) {
        if (e.message === 'disabled') {
          // this.$notification['error']({
          //   message: '无法登录',
          //   description: '此账号已被禁用'
          // })
        } else {
          this.$notification['error']({
            message: '无法登录',
            description: '账号或密码错误'
          })
        }

        this.$tkParse.setSessionToken(null)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
